<template>
<section>
  <Title class="has-text-centered" />
  <h2 class="title has-text-centered"><i>Page Not Found</i></h2>
</section>
</template>

<script>
  import Social from '@/components/Layout/Home/Social'
  import Title from "@/components/Layout/Home/Title";
  import Technologies from "../components/Layout/Home/Technologies";
  export default {

    components: {Technologies, Title, Social},
    name: 'NotFound',
    mounted() {
    },
  }

</script>
